module.exports = __webpack_public_path__ + "media/images/design/common/images/header_navi_bg_etc-ffc1b259926346260624dd9799d1e4e1.gif";